import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.DelegationHeader', {
    approverOnBehalfOfText: 'You are approving on behalf of',
    reviewerOnBehalfOfText: 'You are reviewing on behalf of',
});
